import fetch from 'utils/fetch';

export const REQUEST_CATALOG = 'REQUEST_CATALOG';
export const RECEIVE_CATALOG = 'RECEIVE_CATALOG';

function requestCatalog(catalog) {
  return {
    type: REQUEST_CATALOG,
    payload: {
      catalog,
    },
  };
}

export function receiveCatalog(nodes) {
  return {
    type: RECEIVE_CATALOG,
    payload: {
      nodes,
    },
  };
}

function fetchCatalog(catalog) {
  return dispatch => {
    dispatch(requestCatalog(catalog));
    fetch(`/catalogs/${catalog}/nodes.json`)
      .then(r => r.json())
      .then(nodes => dispatch(receiveCatalog(nodes)));
  };
}

function shouldFetchCatalog(state) {
  const catalog = state.catalog;
  if (!catalog.root) {
    return true;
  } else if (catalog.isFetching) {
    return false;
  }

  return catalog.didInvalidate;
}

export function fetchCatalogIfNeeded(catalog) {
  return (dispatch, getState) => {
    if (shouldFetchCatalog(getState())) {
      dispatch(fetchCatalog(catalog));
    }
  };
}



// WEBPACK FOOTER //
// ./src/modules/catalog/actions/catalog.js